type FetchEpisodeParams = {
  podcastEpisodeId: string;
};

export type FetchEpisodeResponse = {
  created: string;
  createdUnixTimestamp: number;
  description?: string;
  episodeAudios: any[];
  isDraft: boolean;
  podcastEpisodeId: string;
  podcastEpisodeIsExplicit?: boolean;
  podcastEpisodeNumber?: number;
  podcastEpisodeType?: string;
  podcastSeasonNumber?: number;
  publishOn: string | null;
  safeDescription?: string;
  shareLinkEmbedPath?: string;
  shareLinkPath?: string;
  title?: string;
  episodeImage?: string;
};

export async function fetchEpisode({
  podcastEpisodeId,
}: FetchEpisodeParams): Promise<FetchEpisodeResponse> {
  try {
    const response = await fetch(`/api/podcastepisode/${podcastEpisodeId}`, {
      method: 'GET',
      credentials: 'same-origin',
    });
    if (response.ok) {
      return response.json();
    }
    throw new Error('Unable to fetch podcast episode');
  } catch (err) {
    throw new Error(err.message);
  }
}
